// eslint-disable-next-line import/named
import pkg from 'flexsearch'
const { Index } = pkg
type Id = pkg.Id
// import { Id, Index } from 'flexsearch'

export interface NavObject {
    title: string
    slug: string
}

export type NodeType = 'document' | 'directory' | 'directoryWithIcon'

export interface INode<ContentType> {
    content: ContentType
    icon?: string
    parentSlug?: string
    slug: string
    title: string
}

export abstract class Node<ContentType> implements INode<ContentType> {
    abstract get content(): ContentType

    abstract type: NodeType

    title: string

    parent: Node<any> | 'ROOT'

    _documentsSlug: string

    private _searcher = new Index({ tokenize: 'forward' })

    constructor(title: string, slug: string) {
        this.title = title
        this._documentsSlug = slug
        this.parent = 'ROOT'
    }

    get slug(): string {
        return this.parent === 'ROOT'
            ? this._documentsSlug
            : this.parent.slug + '/' + this._documentsSlug
    }

    private findBy(
        predicate: (node: Node<unknown>) => boolean
    ): Node<unknown> | 'NOT_FOUND' {
        if (predicate(this)) return this
        if (Array.isArray(this.content)) {
            for (let i = 0; i < this.content.length; i++) {
                const k = this.content[i].findBy(predicate)
                if (k !== 'NOT_FOUND') return k
            }
        }

        return 'NOT_FOUND'
    }

    findChildBySlug(slug: string): Node<any> {
        const slugEquals = (node: Node<any>) => node.slug === slug
        const result = this.findBy(slugEquals)
        return result === 'NOT_FOUND' ? this : result
    }

    getBreadcrumbs() {
        const slugsWithTitle: NavObject[] = []
        slugsWithTitle.push({ title: this.title, slug: this._documentsSlug })
        if (this.parent === 'ROOT') {
            return slugsWithTitle
        }
        const parent = this.parent

        slugsWithTitle.push(...parent.getBreadcrumbs())
        return slugsWithTitle
    }

    _flattened(): Node<any>[] {
        if (this.type === 'document') return [this]
        const array = (this.content as unknown as Node<any>[]).reduce(
            (acum: Node<any>[], node: Node<any>) => {
                acum.push(...node._flattened())
                return acum
            },
            [this]
        )
        return array
    }

    initializeSearch(): void {
        this._flattened().forEach((node, i) => {
            const content = node.type === 'document' ? node.content : ''
            this._searcher.add(node.slug, node.title + content)
        })
    }

    search(needle: string): Node<any>[] {
        if (needle.length === 0) return []
        const results = this._searcher
            .search(needle)
            .reduce((res: any, cur: any) => [...res, cur], [] as Id[])
            .reduce((nodes: Node<any>[], slug: Id) => {
                const result = this.findChildBySlug(slug + '')
                return [...nodes, ...[result]]
            }, [])
        return results
    }
}
